import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { InvoicesManagement } from 'features/invoices/components/InvoicesManagement';
import { RootState } from 'store';
import { isOperatorOrHigher } from 'features/auth/helpers';
import routes from 'constants/routes';

export const InvoicesListPage = (): JSX.Element => {
	const auth = useSelector((state: RootState) => state.auth);

	if (!isOperatorOrHigher(auth.user)) {
		return <Redirect to={routes.home} />;
	}

	return (
		<Layout>
			<Grid container spacing={2} sx={{ p: 3 }}>
				<Grid item xs={12}>
					<InvoicesManagement />
				</Grid>
			</Grid>
		</Layout>
	);
};
